import { render } from "./vehicle-spec.vue?vue&type=template&id=1493baf8"
import script from "./vehicle-spec.vue?vue&type=script&lang=js"
export * from "./vehicle-spec.vue?vue&type=script&lang=js"

import exportComponent from "/builds/bluemantis/origo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__